import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

const QuestionSkeleton = () => {
  const { colors } = useTheme();

  return (
    <ContentLoader width="100%" height="200" backgroundColor={colors.gray_500} foregroundColor={colors.gray_300}>
      <rect width="30" height="30" x={30} y={0} />
      <rect width="8" height="8" x={72} y={20} />

      <rect width="1000" height="8" x={100} y={22} />
      <rect width="700" height="8" x={100} y={40} />

      <rect width="500" height="8" x={100} y={90} />
      <rect width="350" height="8" x={100} y={120} />
      <rect width="450" height="8" x={100} y={150} />
      <rect width="300" height="8" x={100} y={180} />
    </ContentLoader>
  );
};

export default QuestionSkeleton;
